import { useTranslation } from 'react-i18next';
import ChatStyles from './Chat.module.css';

const NoConversations = ({ setShowAddGroupMoal }) => {
  const { t } = useTranslation();
  return (
    <div className={ChatStyles.convEmptyWrap}>
      <div className={ChatStyles.convEmptyIcon}>
        <svg width='22' height='22' viewBox='0 0 24 24' fill='none' stroke='#800020' strokeWidth='1.8' strokeLinecap='round' strokeLinejoin='round'>
          <path d='M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z' />
        </svg>
      </div>
      <div className={ChatStyles.convEmptyTitle}>{t('screens.chat.noConvTitle')}</div>
      <div className={ChatStyles.convEmptySub}>{t('screens.chat.noConvSub')}</div>
      <button className={ChatStyles.convEmptyBtn} onClick={() => setShowAddGroupMoal(true)}>
        {t('screens.chat.findColleagues')}
      </button>
    </div>
  );
};

export default NoConversations;
